import Header from './components/header/Header'
import Landing from './components/landing/Landing'
import Recent from './components/recent/Recent'
import Gallery from './components/gallery/Gallery'
import About from './components/about/About'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

const App = () => {

  return (
    <div>
      <Header />
      <Landing />
      <Recent />
      <Gallery />
      <About />
      <Contact />
      <Footer />
    </div>
  )
}

export default App
